import { WriteHook, useMutationManager } from 'react-query-state-manager'

import { submitApplicationDeniedCustomer } from '../service'

export const useSubmitDeniedCustomer: WriteHook<{ id: number }, void> = (opts) =>
  useMutationManager(submitApplicationDeniedCustomer, opts)
